import React from "react";
import CountUp from 'react-countup';
import "../../styles/contadores.css"; // Certifique-se de criar o arquivo de estilos adequado
import ClinicaAcessivel from "../../img/acessivel.png";
import AutismoIcon from "../../img/autismo_sf.png";

const Contadores: React.FC = () => {
  return (
    <>
      <div className="container-contadores">
        <div className="teste_zoom">
          <div className="plano_acessivel">
            <img src={ClinicaAcessivel} alt="Clinica Acessivel" className="logo_acessivel" />
            <p className="text_acessivel">
              Com mais de 25 anos de história, a Clínica Mediação reafirma seu compromisso social ao oferecer um plano de atendimento que adapta os valores das consultas à realidade financeira de cada família — garantindo que o acesso às terapias seja justo, humanizado e verdadeiramente acessível a todos.
              <br />
              <br />
              Fale conosco e agende uma avaliação. Estamos aqui para cuidar de você.
            </p>
          </div>
        </div>
      </div>

      <div className="fundo_autismo">
        <div className="contadores-container">
          <div className="contador-card">
            <a href="https://www.gov.br/previdencia/pt-br/noticias/2025/abril/inss-no-dia-mundial-do-autismo-conscientizacao-direitos-e-inclusao-social" target="_blank" rel="noopener noreferrer" className="autismo-link">
              <img src={AutismoIcon} alt="Símbolo Autismo" className="autismo-icon" />
            </a>
            <span>
              <CountUp start={1} end={1900} duration={5} separator="." />
              <span className="plus-simbolo">+</span>
            </span>
            <p>Atendimentos Mensais</p>
          </div>
          <div className="contador-card">
            <a href="https://www.gov.br/previdencia/pt-br/noticias/2025/abril/inss-no-dia-mundial-do-autismo-conscientizacao-direitos-e-inclusao-social" target="_blank" rel="noopener noreferrer" className="autismo-link">
              <img src={AutismoIcon} alt="Símbolo Autismo" className="autismo-icon" />
            </a>
            <span>
              <CountUp start={1} end={6500} duration={5} separator="." />
              <span className="plus-simbolo">+</span>
            </span>
            <p>Famílias Alcançadas</p>
          </div>
          <div className="contador-card">
            <a href="https://www.gov.br/previdencia/pt-br/noticias/2025/abril/inss-no-dia-mundial-do-autismo-conscientizacao-direitos-e-inclusao-social" target="_blank" rel="noopener noreferrer" className="autismo-link">
              <img src={AutismoIcon} alt="Símbolo Autismo" className="autismo-icon" />
            </a>
            <span>
              <CountUp start={1} end={19000} duration={8} separator="." />
              <span className="plus-simbolo">+</span>
            </span>
            <p>Atendimentos Anuais</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contadores;